import { useState } from 'react';

import { mapperResponseToDetail } from 'mappers/mapperResponseToDetail';
import { mapperResponseToNewDetail } from 'mappers/mapperResponseToNewDetail';

import * as api from '../services/api';


export const useControlDetail = (handleShowError) => {
  const [showDetail, setShowDetail] = useState(false);
  const [detail, setDetail] = useState(null);

  const handleLoadDetail = async (id, originURL, isShowroom, countryIso, languageIso, draft) => {
    setShowDetail(true);
    try {
      const response = await api.getDetail(originURL, isShowroom, id, countryIso, languageIso, draft);

      const newDetail = response?.data?.isNewStructureId
        ? mapperResponseToNewDetail(response?.data, draft, countryIso, languageIso)
        : mapperResponseToDetail(response?.data, draft);

      setDetail(newDetail);
      handleShowError(false);
    } catch (e) {
      setDetail(null);
      handleShowError(true);
    }
  };

  const handleClickDetail = (e, id, originURL, isShowroom, countryIso, languageIso, draft) => {
    if (e.target.tagName !== 'BUTTON') {
      if (document.referrer) {
        const url = new URL(window.parent.location.href);
        url.searchParams.set('detailid', id);
        window.parent.history.pushState(null, null, url);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('detailid', id);
        window.history.pushState(null, null, url);
      }
      setShowDetail(true);
      handleLoadDetail(id, originURL, isShowroom, countryIso, languageIso, draft);
    }
  };

  const handleResetDetail = () => {
    setShowDetail(false);
    setDetail(null);
  };

  return {
    showDetail,
    detail,
    handleLoadDetail,
    handleClickDetail,
    handleResetDetail,
  };
};
